class FormSection {
    Id: number;
    Description: string;
    ParentFormSection: any;
    Sequence: number;
    Questions: any[];

    constructor(id: number, description: string, parentFormSection: any, sequence: number, questions: any[]) {
        this.Id = id;
        this.Description = description;
        this.ParentFormSection = parentFormSection;
        this.Sequence = sequence;
        this.Questions = questions;
    }
}

export default FormSection;